export default __webpack_public_path__ + "092023561fa01cbdad8d5ee2d4e1b823.png";